import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CollapsibleContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    CollapsiblePlacement
} from "../../type";

export const COLLAPSIBLE_PLACEMENT_PADDINGS: Record<CollapsiblePlacement, "paddingBottom" | "paddingTop"> = {
    before: "paddingBottom",
    after: "paddingTop"
};

const stylesheet = StyleSheet.create({
    content: {
        flexDirection: "column"
    },
    container: {
        alignSelf: "stretch",
        minWidth: 0
    }
});

export const useStyles = ({
    placement,
    spaces
}: CollapsibleContentDynamicStyleType) => {
    const styles = {
        content: {
            [COLLAPSIBLE_PLACEMENT_PADDINGS[placement]]: spaces.spacingSm,
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
